// Screen variable constants only.

export const PROPERTY_TYPE = {
  FIELD_NAME: {
    TYPE_SINGLE_FAMILY: 'propertyType_singleFamily_isEnabled',
    TYPE_MULTI_FAMILY: 'propertyType_multiFamily_isEnabled',
    FOUR_UNITS_OR_FEWER: 'propertyType_fourUnitsOrFewer',
    FIVE_UNITS_OR_MORE: 'propertyType_fiveUnitsOrMore',
    THREE_UNITS_OR_MORE: 'propertyType_multiFamily_threeUnitsOrMore_isEnabled',
    NUMBER_OF_UNITS: 'propertyType_numberOfUnits',
    FOUR_UNITS_OR_LESS: 'propertyType_multiFamily_fourUnitsOrLess_isEnabled',
  },
};

export const SECURITY_DEPOSIT = {
  FIELD_NAME: {
    IS_ENABLED: 'securityDeposit_isEnabled',
    BANK_NAME: 'securityDeposit_bankName',
    BANK_ADDRESS: 'securityDeposit_bankAddress',
    AMOUNT: 'securityDeposit_amount',
    UPON_SIGNING: 'securityDeposit_uponSigning',
    START_MOVE_IN_DATE: 'securityDeposit_startMoveInDate',
    CLEANING_COST: 'securityDeposit_cleaningCost_isEnabled',
    INTEREST: 'securityDeposit_interest_isEnabled',
    TEN_UNITS_OR_MORE: 'securityDeposit_tenUnitsOrMore_isEnabled',
    RENTAL_SECURITY_INSURANCE: 'securityDeposit_tenUnitsOrMore_rentalSecurityInsurance_isEnabled',
    MONTHLY_PAYMENT_PLAN: 'securityDeposit_tenUnitsOrMore_monthlyPaymentPlan_isEnabled',
    REDUCED_SECURITY_DEPOSIT: 'securityDeposit_tenUnitsOrMore_reducedSecurityDeposit_isEnabled',
    INTEREST_RATE: 'securityDeposit_interestRate',
    TWO_EQUAL_INSTALLMENTS: 'securityDeposit_twoEqualInstallments',
    THREE_EQUAL_INSTALLMENTS: 'securityDeposit_threeEqualInstallments',
  },
  LABEL: {
    AMOUNT: 'Security deposit',
    BANK_NAME: 'Name of deposit bank',
    BANK_ADDRESS: 'Bank address (street, city, state, ZIP code)',
    UPON_SIGNING: 'Upon signing the lease',
    START_MOVE_IN_DATE: 'The lease start/move-in date',
  },
  BOUNDS: {
    MAX_AMOUNT: 10000,
  },
};

export const INSUFFICIENT_FUNDS_FEE = {
  FIELD_NAME: {
    IS_ENABLED: 'insufficientFundsFee_isEnabled',
    AMOUNT: 'insufficientFundsFee_amount',
    ACTUAL_COST: 'insufficientFundsFee_actualCost_isEnabled',
    FLAT_FEE: 'insufficientFundsFee_flatFee_isEnabled',
    FLAT_FEE_AMOUNT: 'insufficientFundsFee_flatFee_amount',
  },
  LABEL: {
    AMOUNT: 'Insufficient-funds fee',
  },
  BOUNDS: {
    V1: {
      MAX_AMOUNT: 100,
    },
    V2: {
      MAX_AMOUNT: 35,
    },
    V3: {
      MAX_AMOUNT: 100,
    },
  },
};

export const PETS = {
  FIELD_NAME: {
    BREED: 'pets_pet_breed',
    GENDER: 'pets_pet_gender',
    IS_ENABLED: 'pets_isEnabled',
    PET_IS_ENABLED: 'pets_pet_isEnabled',
    LICENSE_NUMBER: 'pets_pet_licenseNumber',
    NAME: 'pets_pet_name',
    NON_REFUNDABLE_FEE: 'pets_nonRefundableFee',
    RENT_AMOUNT_PER_MONTH: 'pets_rentAmountPerMonth',
    REFUNDABLE_DEPOSIT: 'pets_refundableDeposit',
    REQUIRES_INSURANCE_COVERAGE: 'pets_requiresInsuranceCoverage',
    TYPE: 'pets_pet_type',
    WEIGHT: 'pets_pet_weight',
    IS_NO_ADDITIONAL_CHARGE: 'pets_noAdditionalCharge_isEnabled',
    IS_MONTHLY: 'pets_rentAmountPerMonth_isEnabled',
    IS_FEE_NONREFUNDABLE: 'pets_nonRefundableFee_isEnabled',
    IS_DEPOSIT_REFUNDABLE: 'pets_refundableDeposit_isEnabled',
    IS_DEPOSIT_REFUNDABLE_AND_MONTHLY: 'pets_refundableDepositAndRentAmountPerMonth_isEnabled',
    NONREFUNDABLE_UPON_SIGNING: 'pets_nonRefundableFee_uponSigning',
    NONREFUNDABLE_START_MOVE_IN_DATE: 'pets_nonRefundableFee_startMoveInDate',
    NONREFUNDABLE_TWO_EQUAL_INSTALLMENTS: 'pets_nonRefundableFee_twoEqualInstallments',
    NONREFUNDABLE_THREE_EQUAL_INSTALLMENTS: 'pets_nonRefundableFee_threeEqualInstallments',
    REFUNDABLE_DEPOSIT_UPON_SIGNING: 'pets_refundableDeposit_uponSigning',
    REFUNDABLE_DEPOSIT_START_MOVE_IN_DATE: 'pets_refundableDeposit_startMoveInDate',
    REFUNDABLE_DEPOSIT_TWO_EQUAL_INSTALLMENTS: 'pets_refundableDeposit_twoEqualInstallments',
    REFUNDABLE_DEPOSIT_THREE_EQUAL_INSTALLMENTS: 'pets_refundableDeposit_threeEqualInstallments',
  },
  ERROR_MESSAGE: {
    BREED: 'Enter a valid pet breed',
    PET_IS_ENABLED: 'pets_pet_isEnabled',
    LICENSE_NUMBER: 'Enter a valid license number',
    NAME: 'Enter a valid pet name',
    NON_REFUNDABLE_FEE: 'pets_nonRefundableFee',
    RENT_AMOUNT_PER_MONTH: 'pets_rentAmountPerMonth',
    REFUNDABLE_DEPOSIT: 'pets_refundableDeposit',
    REQUIRES_INSURANCE_COVERAGE: 'pets_requiresInsuranceCoverage',
    WEIGHT: 'Enter a weight to the nearest pound',
  },
  LABEL: {
    BREED: 'Breed',
    GENDER: 'Gender',
    IS_ENABLED: 'Pets are not allowed if you select no.',
    LICENSE_NUMBER: 'License number',
    NAME: 'Name',
    NON_REFUNDABLE_FEE: 'Non-refundable fee',
    OTHER_TYPE: 'Type of pet',
    RENT_AMOUNT_PER_MONTH: 'PetInformation rent',
    REFUNDABLE_DEPOSIT: 'Refundable deposit',
    REQUIRES_INSURANCE_COVERAGE: 'Will your lease require renters insurance coverage for pets?',
    TYPE: 'Type',
    WEIGHT: 'Weight',
  },
  BOUNDS: {
    V1: {
      MAX_DEPOSIT_AMOUNT: 1000,
    },
    V2: {
      MAX_DEPOSIT_AMOUNT: 1500,
      MAX_NON_REFUNDABLE_FEE: 1000,
    },
    V3: {
      MAX_DEPOSIT_AMOUNT: 1500,
    },
    V4: {
      MAX_DEPOSIT_AMOUNT: 1500,
      MAX_NON_REFUNDABLE_FEE: 1000,
    },
    V5: {
      MAX_DEPOSIT_AMOUNT: 1500,
      MAX_NON_REFUNDABLE_FEE: 1000,
    },
    V6: {
      MAX_DEPOSIT_AMOUNT: 1500,
      MAX_NON_REFUNDABLE_FEE: 1000,
    },
  },
};

export const NON_REFUNDABLE_FEES = {
  FIELD_NAME: {
    AMOUNT: 'nonRefundableFees_amount',
    IS_ENABLED: 'nonRefundableFees_isEnabled',
    NAME: 'nonRefundableFees_name',
    FIRST_PAY_DUE_START: 'nonRefundableFees_firstPaymentDueStart',
    FIRST_PAY_DUE_SIGN: 'nonRefundableFees_firstPaymentDueSign',
    TWO_EQUAL_INSTALLMENTS: 'nonRefundableFees_twoEqualInstallments',
    THREE_EQUAL_INSTALLMENTS: 'nonRefundableFees_threeEqualInstallments',
  },
  LABEL: {
    AMOUNT: 'Fee amount',
    NAME: 'Fee name',
  },
  BOUNDS: {
    MAX_FEE_AMOUNT: 300,
  },
};

export const SNOW_REMOVAL = {
  FIELD_NAME: {
    IS_ENABLED: 'snowRemoval_isEnabled',
    CUSTOM_AREA_IS_ENABLED: 'snowRemoval_customArea_isEnabled',
    CUSTOM_AREA_RESPONSIBILITY: 'snowRemoval_customArea_responsibility',
    CUSTOM_AREA_DESCRIPTION: 'snowRemoval_customArea_description',
    COMMON_SIDEWALK: 'snowRemoval_commonSidewalkResponsibility',
    MAIN_EXTERIOR_STAIRS: 'snowRemoval_mainExteriorStairsResponsibility',
    SECONDARY_STAIRS: 'snowRemoval_secondaryStairsResponsibility',
    COMMON_DRIVEWAY: 'snowRemoval_commonDrivewayResponsibility',
    DRIVE_LANES: 'snowRemoval_driveLanesResponsibility',
    PARKING_SPACES: 'snowRemoval_parkingSpacesResponsibility',
  },
  LABEL: {
    COMMON_SIDEWALK: 'Common sidewalk',
    MAIN_EXTERIOR_STAIRS: 'Main exterior stairs',
    SECONDARY_STAIRS: 'Secondary stairs',
    COMMON_DRIVEWAY: 'Common driveway',
    DRIVE_LANES: 'Drive lanes',
    PARKING_SPACES: 'Parking spaces',
  },
  LANDLORD: 'landlord',
  TENANT: 'tenant',
  NA: 'not applicable',
};

export const PERSON = {
  FIELD_NAME: {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PHONE_NUMBER: 'telephoneNumber',
    EMAIL_ADDRESS: 'email',
    MAILING_ADDRESS: 'mailingAddress',
    APPLICATION_ID: 'applicationId',
    APPLICATION_STATUS: 'applicationStatus',
    RENTAL_PROTECTION_STATUS: 'rentalProtectionStatus',
  },
  ERROR_MESSAGE: {
    FIRST_NAME: 'Enter a valid first name',
    LAST_NAME: 'Enter a valid last name',
    PHONE_NUMBER: 'Phone number must be in the format (XXX) XXX-XXXX',
    EMAIL_ADDRESS: 'Enter a valid, unique email',
    EMAIL_ADDRESS_SPACE: 'Emails cannot contain blank spaces',
    MAILING_ADDRESS: 'Enter a valid mailing address',
  },
  LABEL: {
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    EMAIL: 'Email address',
    PHONE_NUMBER: 'Phone number',
    MAILING_ADDRESS: 'Address for receiving notice',
    MAILING_ADDRESS_IMPORTANT: 'Address for receiving important notices',
    MAILING_ADDRESS_TENANT: 'Address for receiving notices prior to the lease’s start date',
  },
};

export const TENANT = {
  FIELD_NAME: {
    MAX_NUMBER_OF_TENANTS: 'tenant_maxNumberOfTenants',
  },
};

export const PROPERTY_ADDRESS = {
  FIELD_NAME: {
    PROPERTY_ADDRESS: 'address_propertyAddress',
    DEVELOPMENT_ADDRESS: 'propertyType_multiFamily_developmentAddress',
    UNIT_NUMBER: 'propertyType_multiFamily_unitNumber',
    PART_OF_COMPLEX: 'propertyType_multiFamily_partOfComplex',
    COMPLEX_ADDRESS: 'propertyType_multiFamily_addressOfComplex',
    STREET: 'propertyAddress_street',
    ADDRESS_LINE_2: 'propertyAddress_addressLine2',
    ZIP: 'propertyAddress_zip',
    STATE: 'propertyAddress_state',
    CITY: 'propertyAddress_city',
    MULTIFAMILY_STREET: 'propertyType_multiFamily_street',
    MULTIFAMILY_ADDRESS_LINE_2: 'propertyType_multiFamily_addressLine2',
    MULTIFAMILY_ZIP: 'propertyType_multiFamily_zip',
    MULTIFAMILY_STATE: 'propertyType_multiFamily_state',
    MULTIFAMILY_CITY: 'propertyType_multiFamily_city',
  },
  ERROR_MESSAGE: {
    PROPERTY_ADDRESS: 'Enter a valid property address',
    DEVELOPMENT_ADDRESS: 'Enter a valid development address',
    COMPLEX_ADDRESS: 'Enter a valid complex address',
  },
};

export const ZONING = {
  FIELD_NAME: {
    ZONING_DISTRICT: 'zoning_zoningDistrict',
  },
};

export const LEASE_TERMS = {
  FIELD_NAME: {
    IS_FIXED: 'terms_fixed_isEnabled',
    IS_MONTH_TO_MONTH: 'terms_monthToMonth_isEnabled',
    START_DATE: 'terms_startDate',
    END_DATE: 'terms_fixed_endDate',
  },
  ERROR_MESSAGE: {
    START_DATE_IN_PAST: 'Enter a valid date that is after today',
    END_DATE_IN_PAST: 'Enter a valid date that is after today and after the start date',
    END_DATE_PAST_ONE_YEAR: 'Enter a valid date that is less than 1 year after the start date',
    END_DATE_PAST_TWO_YEARS: 'Enter a valid date that is less than 2 years after the start date',
  },
  LABEL: {
    FIXED_HEADER: 'Fixed term',
    FIXED_CONTENT: 'Specify start and end date',
    MONTH_TO_MONTH_HEADER: 'Month-to-month',
    MONTH_TO_MONTH_CONTENT: 'Specify start date, no end date',
    START_DATE: 'Lease start/move-in date',
    END_DATE: 'Lease end date',
  },
};

export const STORAGE = {
  FIELD_NAME: {
    SPACE_NONE: 'storage_none_isEnabled',
    SPACE_PROVIDED: 'storage_provided_isEnabled',
    SPACE_INCLUDED: 'storage_provided_included_isEnabled',
    SPACE_ADDITIONAL_FEE: 'storage_provided_additionalFee_isEnabled',
    SPACE_PROVIDED_DESCRIPTION: 'storage_provided_description',
    SPACE_ADDITIONAL_FEE_AMOUNT: 'storage_provided_additionalFee_amount',
  },
};

export const BASE_RENT = {
  FIELD_NAME: {
    AMOUNT: 'baseRent_amount',
    DUE_DATE: 'baseRent_dueDate',
    FIRST_PAY_DUE_START: 'baseRent_firstPaymentDue_start',
    FIRST_PAY_DUE_SIGN: 'baseRent_firstPaymentDue_sign',
    FIRST_PAY_DUE_MONTHLY_START: 'baseRent_firstPaymentDue_monthlyStart',
  },
  FIELD_VALUE: {
    FIRST_PAY_LEASE_SIGN: 'sign',
    FIRST_PAY_LEASE_START: 'start',
  },
  BOUNDS: {
    MAX_AMOUNT: 100000,
  },
};

export const LATE_RENT = {
  FIELD_NAME: {
    LATE_DAYS: 'lateRent_lateDays',
    FEE_AMOUNT: 'lateRent_feeAmount',
    FEE_AMOUNT_PER_DAY: 'lateRent_feeAmountPerDay',
  },
  BOUNDS: {
    MIN_DAYS: 1,
    MAX_DAYS: 29,
  },
};

export const PARKING = {
  FIELD_NAME: {
    IS_NONE: 'parking_none_isEnabled',
    IS_PROVIDED: 'parking_provided_isEnabled',
    IS_INCLUDED: 'parking_provided_included_isEnabled',
    IS_ADDITIONAL_FEE: 'parking_provided_additionalFee_isEnabled',
    ADDITIONAL_FEE_AMOUNT: 'parking_provided_additionalFee_amount',
    ADDITIONAL_FEE_HOW_MANY_VEHICLES: 'parking_provided_additionalFee_howManyVehicles',
    PROVIDED_IS_ANY_OPEN_SPOT: 'parking_provided_whereToPark_anyOpenSpot',
    PROVIDED_IS_RESERVED: 'parking_provided_whereToPark_reservedSpot_isEnabled',
    PROVIDED_RESERVED_SPACE: 'parking_provided_whereToPark_reservedSpot_space',
  },
};

export const APPLIANCES = {
  FIELD_NAME: {
    REFRIGERATOR_IS_INCLUDED: 'refrigerator_isIncluded',
    OVEN_RANGE_IS_INCLUDED: 'ovenRange_isIncluded',
    MICROWAVE_IS_INCLUDED: 'microwave_isIncluded',
    DISHWASHER_IS_INCLUDED: 'dishwasher_isIncluded',
    CLOTHES_WASHER_IS_INCLUDED: 'clothesWasher_isIncluded',
    CLOTHES_DRYER_IS_INCLUDED: 'clothesDryer_isIncluded',
    WINDOW_AIR_CONDITIONER_IS_INCLUDED: 'windowAirConditioner_isIncluded',
    IS_ENABLED: 'appliances_isEnabled',
    NAME: 'appliances_name',
  },
  ERROR_MESSAGE: {
    NAME: 'Enter a valid name',
  },
};

export const FIXTURES_APPLIANCES_PERSONAL_PROPERTY = {
  FIELD_NAME: {
    IS_ENABLED: 'fixturesAppliancesPersonalProperty_isEnabled',
    NAME: 'fixturesAppliancesPersonalProperty_name',
    COST: 'fixturesAppliancesPersonalProperty_cost',
  },
};

export const ELECTRICITY = {
  FIELD_NAME: {
    IS_ENABLED: 'electricity_isEnabled',
    TENANT_RESPONSIBILITY: 'electricity_tenantResponsibility_isEnabled',
    LANDLORD_RESPONSIBILITY: 'electricity_landlordResponsibility_isEnabled',
    FIXED_AMOUNT_SELECTED: 'electricity_landlordResponsibility_additionalFixedAmount_isEnabled',
    FIXED_AMOUNT_VALUE: 'electricity_landlordResponsibility_additionalFixedAmount_value',
    VARIABLE_COST_SELECTED: 'electricity_landlordResponsibility_additionalVariableCostSelected',
    SERVICE_PROVIDER: 'electricity_tenantResponsibility_serviceProvider',
    MULTIFAMILY_TENANT_RESPONSIBILITY: {
      DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT:
        'propertyType_multiFamily_electricity_deliveredToAreasOtherThanTenantsUnit',
    },
    MULTIFAMILY_LANDLORD_RESPONSIBILITY: {
      MONTHLY_COST_PERCENTAGE: 'propertyType_multiFamily_electricity_monthlyCostPercentage',
      FORMULA: 'propertyType_multiFamily_electricity_formula',
      BILL_AMOUNT: 'propertyType_multiFamily_electricity_billAmount',
    },
    FIXED_AMOUNT_CALCULATION: 'electricity_calculation',
    ADMINSTRATIVE_FEE: 'electricity_administrativeFee',
    OTHER_METHOD: 'electricity_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'electricity_otherMethodDescription',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT: 'electricity_deliveredToAreasOtherThanTenantsUnit_isEnabled', // For new oregon, no longer multifamily
    INDIVIDUALLY_METERED: 'electricity_individuallyMetered',
    ANNUAL_COSTS: 'electricity_annualCosts',
    OWN_PROPERTY_YES: 'electricity_ownProperty_yes',
    OWN_PROPERTY_NO: 'electricity_ownProperty_no',
    KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT: 'electricity_knowAnnualCostsSimilarRentalUnit_isEnabled',
    KNOW_ANNUAL_COSTS_UTILITY_PROVIDER: 'electricity_knowAnnualCostsUtilityProvider_isEnabled',
  },
};

export const NATURAL_GAS = {
  FIELD_NAME: {
    IS_ENABLED: 'naturalGas_isEnabled',
    TENANT_PAYS_IN_ADDITION_TO_RENT: 'naturalGas_tenantPaysInAdditionToRent',
    TENANT_RESPONSIBILITY: 'naturalGas_tenantResponsibility_isEnabled',
    SERVICE_PROVIDER: 'naturalGas_tenantResponsibility_serviceProvider',
    LANDLORD_RESPONSIBILITY: 'naturalGas_landlordResponsibility_isEnabled',
    FIXED_AMOUNT_SELECTED: 'naturalGas_landlordResponsibility_additionalFixedAmount_isEnabled',
    FIXED_AMOUNT_VALUE: 'naturalGas_landlordResponsibility_additionalFixedAmount_value',
    VARIABLE_COST_SELECTED: 'naturalGas_landlordResponsibility_additionalVariableCostSelected',
    MULTIFAMILY_TENANT_RESPONSIBILITY: {
      DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT:
        'propertyType_multiFamily_naturalGas_deliveredToAreasOtherThanTenantsUnit',
    },
    MULTIFAMILY_LANDLORD_RESPONSIBILITY: {
      MONTHLY_COST_PERCENTAGE: 'propertyType_multiFamily_naturalGas_monthlyCostPercentage',
      FORMULA: 'propertyType_multiFamily_naturalGas_formula',
      BILL_AMOUNT: 'propertyType_multiFamily_naturalGas_billAmount',
    },
    FIXED_AMOUNT_CALCULATION: 'naturalGas_calculation',
    ADMINSTRATIVE_FEE: 'naturalGas_administrativeFee',
    OTHER_METHOD: 'naturalGas_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'naturalGas_otherMethodDescription',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT: 'naturalGas_deliveredToAreasOtherThanTenantsUnit_isEnabled',
    INDIVIDUALLY_METERED: 'naturalGas_individuallyMetered',
    ANNUAL_COSTS: 'naturalGas_annualCosts',
    OWN_PROPERTY_YES: 'naturalGas_ownProperty_yes',
    OWN_PROPERTY_NO: 'naturalGas_ownProperty_no',
    KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT: 'naturalGas_knowAnnualCostsSimilarRentalUnit_isEnabled',
    KNOW_ANNUAL_COSTS_UTILITY_PROVIDER: 'naturalGas_knowAnnualCostsUtilityProvider_isEnabled',
  },
};

export const WATER_SEWER = {
  FIELD_NAME: {
    IS_ENABLED: 'waterSewer_isEnabled',
    TENANT_RESPONSIBILITY: 'waterSewer_tenantResponsibility_isEnabled',
    SERVICE_PROVIDER: 'waterSewer_tenantResponsibility_serviceProvider',
    LANDLORD_RESPONSIBILITY: 'waterSewer_landlordResponsibility_isEnabled',
    FIXED_AMOUNT_SELECTED: 'waterSewer_landlordResponsibility_additionalFixedAmountSelected',
    FIXED_AMOUNT_VALUE: 'waterSewer_landlordResponsibility_additionalFixedAmountValue',
    VARIABLE_COST_SELECTED: 'waterSewer_landlordResponsibility_additionalVariableCostSelected',
    MULTIFAMILY_TENANT_RESPONSIBILITY: {
      DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT:
        'propertyType_multiFamily_waterSewer_deliveredToAreasOtherThanTenantsUnit',
    },
    MULTIFAMILY_LANDLORD_RESPONSIBILITY: {
      MONTHLY_COST_PERCENTAGE: 'propertyType_multiFamily_waterSewer_monthlyCostPercentage',
      FORMULA: 'propertyType_multiFamily_waterSewer_formula',
      BILL_AMOUNT: 'propertyType_multiFamily_waterSewer_billAmount',
    },
    WATER_SUBMETER: 'propertyType_multiFamily_waterSubmetering_isEnabled',
    WATER_SUBMETER_LOCATION: 'propertyType_multiFamily_waterSubmetering_location',
    FIXED_AMOUNT_CALCULATION: 'waterSewer_calculation',
    ADMINSTRATIVE_FEE: 'waterSewer_administrativeFee',
    OTHER_METHOD: 'waterSewer_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'waterSewer_otherMethodDescription',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT: 'waterSewer_deliveredToAreasOtherThanTenantsUnit_isEnabled',
    ANNUAL_COSTS: 'waterSewer_annualCosts',
    OWN_PROPERTY_YES: 'waterSewer_ownProperty_yes',
    OWN_PROPERTY_NO: 'waterSewer_ownProperty_no',
    KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT: 'waterSewer_knowAnnualCostsSimilarRentalUnit_isEnabled',
    KNOW_ANNUAL_COSTS_UTILITY_PROVIDER: 'waterSewer_knowAnnualCostsUtilityProvider_isEnabled',
  },
};

export const WATER_BILLING = {
  FIELD_NAME: {
    ESTIMATED_MONTHLY_CHARGE: 'propertyType_multiFamily_waterSubmetering_estimatedMonthlyCharge',
    AVERAGE_COMPARATIVE: 'propertyType_multiFamily_waterSubmetering_averageComparative',
    AVERAGE_FAMILY: 'propertyType_multiFamily_waterSubmetering_averageFamily',
    PHONE_NUMBER: 'propertyType_multiFamily_waterSubmetering_phoneNumber',
    MAILING_ADDRESS: 'propertyType_multiFamily_waterSubmetering_mailingAddress',
    EMAIL_ADDRESS: 'propertyType_multiFamily_waterSubmetering_emailAddress',
    TIME_AND_DATES: 'propertyType_multiFamily_waterSubmetering_timeAndDate',
    WATER_DUE_DATE: 'propertyType_multiFamily_waterSubmetering_waterDueDate',
    WATER_PAYMENT_PROCEDURES: 'propertyType_multiFamily_waterSubmetering_waterPaymentProcedures',
    LATE_FEES: 'propertyType_multiFamily_waterSubmetering_lateFees',
    PROVIDER: 'propertyType_multiFamily_waterSubmetering_provider',
    CHARGES: 'propertyType_multiFamily_waterSubmetering_charges',
  },
  ERROR_MESSAGE: {
    PHONE_NUMBER: 'Phone number must be in the format (XXX) XXX-XXXX',
  },
};

export const TRASH_REMOVAL = {
  FIELD_NAME: {
    IS_ENABLED: 'trashRemoval_isEnabled',
    SERVICE_PROVIDER: 'trashRemoval_serviceProvider',
    TENANT_RESPONSIBILITY: 'trashRemoval_tenantResponsibility_isEnabled',
    LANDLORD_RESPONSIBILITY: 'trashRemoval_landlordResponsibility_isEnabled',
    SERVICE_PROVIDER_TENANT_RESPONSIBILITY: 'trashRemoval_tenantResponsibility_serviceProvider',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT: 'trashRemoval_deliveredToAreasOtherThanTenantsUnit',
    FIXED_AMOUNT_VALUE: 'trashRemoval_landlordResponsibility_fixedAmountValue',
    FIXED_AMOUNT_CALCULATION: 'trashRemoval_calculation',
    ADMINSTRATIVE_FEE: 'trashRemoval_administrativeFee',
    OTHER_METHOD: 'trashRemoval_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'trashRemoval_otherMethodDescription',
  },
};

export const LANDSCAPING = {
  FIELD_NAME: {
    IS_ENABLED: 'landscaping_isEnabled',
    TENANT_RESPONSIBILITY: 'landscaping_tenantResponsibility',
    LANDLORD_RESPONSIBILITY: 'landscaping_landlordResponsibility',
    SERVICES: 'landscaping_landlordResponsibility_services',
    VARIABLE_COST: 'landscaping_landlordResponsibility_variableCostSelected',
    NO_ADDITIONAL_FEES: 'landscaping_landlordResponsibility_noAdditionalFeeSelected',
  },
};

export const HEATING_OIL = {
  FIELD_NAME: {
    IS_ENABLED: 'heatingOil_isEnabled',
    TENANT_PAYS_IN_ADDITION_TO_RENT: 'heatingOil_tenantPaysInAdditionToRent',
    SERVICE_PROVIDER: 'heatingOil_serviceProvider',
    MULTIFAMILY_TENANT_RESPONSIBILITY: {
      DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT:
        'propertyType_multiFamily_heatingOil_deliveredToAreasOtherThanTenantsUnit',
    },
    TENANT_RESPONSIBILITY: 'heatingOil_tenantResponsibility_isEnabled',
    SERVICE_PROVIDER_TENANT_RESPONSIBILITY: 'heatingOil_tenantResponsibility_serviceProvider',
    LANDLORD_RESPONSIBILITY: 'heatingOil_landlordResponsibility_isEnabled',
    FIXED_AMOUNT_VALUE: 'heatingOil_landlordResponsibility_fixedAmountValue',
    FIXED_AMOUNT_CALCULATION: 'heatingOil_calculation',
    ADMINSTRATIVE_FEE: 'heatingOil_administrativeFee',
    OTHER_METHOD: 'heatingOil_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'heatingOil_otherMethodDescription',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT: 'heatingOil_deliveredToAreasOtherThanTenantsUnit_isEnabled',
    INDIVIDUALLY_METERED: 'heatingOil_individuallyMetered',
    ANNUAL_COSTS: 'heatingOil_annualCosts',
    OWN_PROPERTY_YES: 'heatingOil_ownProperty_yes',
    OWN_PROPERTY_NO: 'heatingOil_ownProperty_no',
    KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT: 'heatingOil_knowAnnualCostsSimilarRentalUnit_isEnabled',
    KNOW_ANNUAL_COSTS_UTILITY_PROVIDER: 'heatingOil_knowAnnualCostsUtilityProvider_isEnabled',
  },
};

export const HEAT_HEATING = {
  FIELD_NAME: {
    IS_ENABLED: 'heatHeating_isEnabled',
    INCLUDED: 'heatHeating_heatHeatingIncluded',
    LANDLORD_RESPONSIBILITY: 'heatHeating_landlordResponsibility',
    MONTHLY_COST_PERCENTAGE: 'heatHeating_multiFamilyLandlordResponsibility_monthlyCostPercentage',
    FORMULA: 'heatHeating_multiFamilyLandlordResponsibility_formula',
  },
};

export const SEPARATE_HEATING_CHARGE = {
  FIELD_NAME: {
    IS_ENABLED: 'propertyType_multiFamily_separateHeatingCharge_isEnabled',
    TENANT_PAYS_IN_ADDITION_TO_RENT: 'propertyType_multiFamily_separateHeatingCharge_tenantPaysInAdditionToRent',
    INCLUDED: 'propertyType_multiFamily_separateHeatingCharge_heatHeatingIncluded',
    MONTHLY_COST_PERCENTAGE: 'propertyType_multiFamily_separateHeatingCharge_monthlyCostPercentage',
    FORMULA: 'propertyType_multiFamily_separateHeatingCharge_formula',
    FIXED_AMOUNT_VALUE: 'propertyType_multiFamily_separateHeatingCharge_tenantPaysInAdditionToRent_fixedAmountValue',
    OTHER_METHOD: 'propertyType_multiFamily_separateHeatingCharge_otherMethod',
    OTHER_METHOD_DESCRIPTION: 'propertyType_multiFamily_separateHeatingCharge_otherMethodDescription',
    CALCULATION: 'propertyType_multiFamily_separateHeatingCharge_calculation',
    DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT:
      'propertyType_multiFamily_separateHeatingCharge_deliveredToAreasOtherThanTenantsUnit_isEnabled',
    ANNUAL_COSTS: 'propertyType_multiFamily_separateHeatingCharge_annualCosts',
    OWN_PROPERTY_YES: 'propertyType_multiFamily_separateHeatingCharge_yes',
    OWN_PROPERTY_NO: 'propertyType_multiFamily_separateHeatingCharge_no',
    KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT:
      'propertyType_multiFamily_separateHeatingCharge_knowAnnualCostsSimilarRentalUnit_isEnabled',
  },
};

export const RADON_HAZARD = {
  FIELD_NAME: {
    NOT_PRESENT: 'radonHazard_unsafeDetected_withReports_none',
    PRESENT: 'radonHazard_unsafeDetected_withReports_present',
    WITH_REPORTS: 'radonHazard_unsafeDetected_withReports_isEnabled',
    REMEDIATED: 'radonHazard_unsafeDetected_remediated',
    HAS_RELATED_REPORTS: 'radonHazard_unsafeDetected_withReports_hasRelatedReports',
  },
  LABELS: {
    RADON_TESTED: 'Do you know of any test that indicated the presence of unsafe levels of radon?',
    NO_TEST: 'No',
    PRESENT: 'Yes, and radon is present',
    REMEDIATED: 'Yes, but radon is remediated',
  },
};

export const LEAD_BASED_PAINT = {
  FIELD_NAME: {
    HAS_ON_PROPERTY: 'leadBasedPaint_hasOnProperty_isEnabled',
    DESCRIPTION: 'leadBasedPaint_hasOnProperty_description',
    HAS_RELATED_REPORTS: 'leadBasedPaint_hasOnProperty_hasRelatedReports_isEnabled',
    REPORTS_DESCRIPTION: 'leadBasedPaint_hasOnProperty_hasRelatedReports_description',
  },
};

export const LEAD_BASED_PAINT_V2 = {
  FIELD_NAME: {
    HAS_ON_PROPERTY: 'leadBasedPaint_hasOnProperty_isEnabled',
    DESCRIPTION: 'leadBasedPaint_hasOnProperty_description',
    HAS_RELATED_REPORTS: 'leadBasedPaint_hasRelatedReports_isEnabled',
    REPORTS_DESCRIPTION: 'leadBasedPaint_hasRelatedReports_description',
  },
};

export const ADDITIONAL_OCCUPANT = {
  FIELD_NAME: {
    IS_ENABLED: 'additionalOccupant_isEnabled',
    FIRST_NAME: 'additionalOccupant_firstName',
    LAST_NAME: 'additionalOccupant_lastName',
    AGE: 'additionalOccupant_age',
    BIRTH_DATE: 'additionalOccupant_birthDate',
  },
  ERROR_MESSAGE: {
    NAME: 'Enter a valid name',
    AGE: 'Enter a valid age',
  },
};

export const LAST_MONTH_RENT = {
  FIELD_NAME: {
    IS_ENABLED: 'lastMonthRent_isEnabled',
    UPON_SIGNING: 'lastMonthRent_uponSigning',
    START_MOVE_IN_DATE: 'lastMonthRent_startMoveInDate',
    TWO_EQUAL_INSTALLMENTS: 'lastMonthRent_twoEqualInstallments',
    THREE_EQUAL_INSTALLMENTS: 'lastMonthRent_threeEqualInstallments',
  },
};

export const PRORATED_RENT = {
  FIELD_NAME: {
    IS_ENABLED: 'proratedRent_isEnabled',
    RENT_AMOUNT: 'proratedRent_rentAmount',
  },
  BOUNDS: {
    MAX_AMOUNT: 100000,
  },
};

export const PRE_OCCUPANCY_AGREEMENT = {
  FIELD_NAME: {
    IS_ENABLED: 'preOccupancyAgreement_isEnabled',
    PROJECT_DESCRIPTION: 'preOccupancyAgreement_projectDescription',
  },
};

export const EASEMENTS_COVENANTS_CONDITIONS_RESTRICTIONS = {
  FIELD_NAME: {
    IS_ENABLED: 'easementsCovenantsConditionsAndRestrictions_isEnabled',
  },
};

export const HOA_RULES = {
  FIELD_NAME: {
    IS_ENABLED: 'hoaRules_isEnabled',
  },
};

export const CONDO_ASSOCIATION_RULES = {
  FIELD_NAME: {
    IS_ENABLED: 'condoAssociationRules_isEnabled',
  },
};

export const MORE_RULES = {
  FIELD_NAME: {
    IS_ENABLED: 'moreRules_isEnabled',
  },
};

export const PROPERTY_USAGE = {
  FIELD_NAME: {
    IS_ENABLED: 'propertyUsage_isEnabled',
    HOLES: 'propertyUsage_holes',
    FASTENED: 'propertyUsage_fastened',
    BALCONY: 'propertyUsage_balcony',
    BALCONY_WEIGHT: 'propertyUsage_balconyWeight',
    TOWELS: 'propertyUsage_towels',
    PROHIBITED_ITEMS: 'propertyUsage_prohibitedItems',
    WAX_CANDLES: 'propertyUsage_waxCandles',
    COOKING: 'propertyUsage_cooking',
    ADVERTISEMENTS: 'propertyUsage_advertisements',
    LOCKS: 'propertyUsage_locks',
    WATERBEDS: 'propertyUsage_waterBeds',
    SMOKING: 'propertyUsage_smoking',
  },
};

export const PROPERTY_USAGE_RULES = [
  {
    LABEL: `The tenant may not, without your written consent, drill holes or use nails, hooks, and screws on the
    property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.HOLES,
  },
  {
    LABEL: `The tenant may not fasten anything to the fixtures, appliances, or to the interior or exterior of the
    property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.FASTENED,
  },
  {
    LABEL: `Any balcony or porch included in the property, or adjacent to the property, may not be altered by the
    tenant or used to store their personal belongings`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.BALCONY,
  },
  {
    LABEL: `The tenant will comply with all weight restrictions on balconies and porches and will not overload
    them`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.BALCONY_WEIGHT,
  },
  {
    LABEL: `No laundry or other items will be hung from any window, balcony, or porch`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.TOWELS,
  },
  {
    LABEL: `The tenant may not bring anything onto the property or grounds which could increase the risk of fire
    (e.g., flammable chemicals)`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.PROHIBITED_ITEMS,
  },
  {
    LABEL: `No wax candles will be used on the property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.WAX_CANDLES,
  },
  {
    LABEL: `The tenant may not cook or barbecue on any porch or balcony or within 15 feet of any building`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.COOKING,
  },
  {
    LABEL: `The tenant won't place any sign, advertisement, or notice so that it’s visible outside the property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.ADVERTISEMENTS,
  },
  {
    LABEL: `The tenant won't add or change any locks without your prior written consent`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.LOCKS,
  },
  {
    LABEL: `Waterbeds and other water furniture are prohibited. Also, unusually heavy items like pianos and safes
    are only allowed if you agree that the weight is reasonable for the property’s floor`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.WATERBEDS,
  },
  {
    LABEL: `Smoking is not permitted on the property, including outdoors within 15 feet of any doorway`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.SMOKING,
  },
];

export const PROPERTY_USAGE_RULES_V2 = [
  {
    LABEL: `The tenant may not, without your written consent, drill holes or use nails, hooks, and screws on the
    property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.HOLES,
  },
  {
    LABEL: `The tenant may not fasten anything to the fixtures, appliances, or to the interior or exterior of the
    property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.FASTENED,
  },
  {
    LABEL: `Any balcony or porch included in the property, or adjacent to the property, may not be altered by the
    tenant or used to store their personal belongings`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.BALCONY,
  },
  {
    LABEL: `The tenant will comply with all weight restrictions on balconies and porches and will not overload
    them`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.BALCONY_WEIGHT,
  },
  {
    LABEL: `No laundry or other items will be hung from any window, balcony, or porch`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.TOWELS,
  },
  {
    LABEL: `The tenant may not bring anything onto the property or grounds which could increase the risk of fire
    (e.g., flammable chemicals)`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.PROHIBITED_ITEMS,
  },
  {
    LABEL: `No wax candles will be used on the property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.WAX_CANDLES,
  },
  {
    LABEL: `The tenant may not cook or barbecue on any porch or balcony or within 15 feet of any building`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.COOKING,
  },
  {
    LABEL: `The tenant won't place any sign, advertisement, or notice so that it’s visible outside the property`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.ADVERTISEMENTS,
  },
  {
    LABEL: `The tenant won't add or change any locks without your prior written consent`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.LOCKS,
  },
  {
    LABEL: `Waterbeds and other water furniture are prohibited. Also, unusually heavy items like pianos and safes
    are only allowed if you agree that the weight is reasonable for the property’s floor.`,
    FIELD_NAME: PROPERTY_USAGE.FIELD_NAME.WATERBEDS,
  },
];

export const RESIDENT_ACTIVITIES = {
  FIELD_NAME: {
    IS_ENABLED: 'residentActivities_isEnabled',
    TRASH: 'residentActivities_trash',
    MAINTENANCE: 'residentActivities_maintenance',
    MARIJUANA: 'residentActivities_marijuana',
  },
};

export const RESIDENT_ACTIVITIES_RULES = [
  {
    LABEL: `The tenant will dispose of trash only in designated areas`,
    FIELD_NAME: RESIDENT_ACTIVITIES.FIELD_NAME.TRASH,
  },
  {
    LABEL: `The tenant will promptly report any repair or maintenance problems to you or your managing agent
    (if any)`,
    FIELD_NAME: RESIDENT_ACTIVITIES.FIELD_NAME.MAINTENANCE,
  },
];

export const RESIDENT_ACTIVITIES_MARIJUANA = [
  {
    LABEL:
      `The tenant will not engage in, or permit, the use or sale of marijuana, ` +
      `or products containing marijuana or THC, on the property or on its grounds`,
    FIELD_NAME: RESIDENT_ACTIVITIES.FIELD_NAME.MARIJUANA,
  },
];

export const KEYS = {
  FIELD_NAME: {
    IS_ENABLED: 'keys_isEnabled',
    DELIVERY: 'keys_delivery',
    VACATES: 'keys_vacates',
    LOSES: 'keys_loses',
  },
};

export const KEYS_RULES = [
  {
    LABEL:
      `The tenant must sign a receipt detailing which keys you give them ` +
      `(e.g., door, mailbox, etc.) and how many of each`,
    FIELD_NAME: KEYS.FIELD_NAME.DELIVERY,
  },
  {
    LABEL:
      `When the tenant moves out, they must return each key you provided. ` +
      `Otherwise, they will be responsible for the cost of re-keying the applicable locks.`,
    FIELD_NAME: KEYS.FIELD_NAME.VACATES,
  },
  {
    LABEL:
      `If the tenant loses a key or requires duplicates, they must notify you ` +
      `or your managing agent and bear the cost. The tenant may not duplicate the keys on their own.`,
    FIELD_NAME: KEYS.FIELD_NAME.LOSES,
  },
];

export const CUSTOM_RULES = {
  FIELD_NAME: {
    IS_ENABLED: 'customRules_isEnabled',
    CUSTOM_RULES: 'customRules_customRules',
  },
};

export const PAYMENT_METHOD = {
  FIELD_NAME: {
    ELECTRONIC_IS_ENABLED: 'paymentMethod_electronic_isEnabled',
    DIRECT_IS_ENABLED: 'paymentMethod_direct_isEnabled',
    CHECK_IS_ENABLED: 'paymentMethod_check_isEnabled',
    CHECK_ADDRESS: 'paymentMethod_check_address',
    ELECTRONIC_SERVICE_TYPE: 'paymentMethod_electronic_serviceType',
    ZILLOW_PAYMENTS_IS_ENABLED: 'paymentMethod_zillowPayments_isEnabled',
    INDIVIDUAL_ELECTRONIC_PAYMENT_IS_ENABLED: 'paymentMethod_electronic_individualPaymentMethod_isEnabled',
    INDIVIDUAL_ELECTRONIC_PAYMENT_NAME: 'paymentMethod_electronic_individualPaymentMethod_name',
  },
  ERROR_MESSAGE: {
    ADDRESS: 'Enter a valid address',
  },
  OTHER_CONSTANTS: {
    ZILLOW_PAYMENTS: 'Zillow Payments',
  },
};

export const RENTERS_INSURANCE = {
  FIELD_NAME: {
    IS_ENABLED: 'rentersInsurance_isEnabled',
    MINIMUM_COVERAGE: 'rentersInsurance_minimumCoverage',
  },
};

export const UTILITIES_PAYMENTS = {
  FIELD_NAME: {
    DAYS_AFTER_BILLING: 'utilitiesPayments_daysAfterBilling',
  },
  BOUNDS: {
    MIN_DAYS: 0,
  },
};

export const TENANT_DEFAULT = {
  FIELD_NAME: {
    UNPAID_RENT: 'tenantDefault_unpaidRent',
    OTHER_VIOLATION: 'tenantDefault_otherViolation',
    DAYS_AFTER_UNPAID: 'tenantDefault_daysAfterUnpaid',
    DAYS_AFTER_RECEIVING_NOTICE: 'tenantDefault_daysAfterReceivingNotice',
  },
  BOUNDS: {
    MIN_DAYS: 7,
    CT_MIN_DAYS: 15,
  },
};

export const HOMEOWNER_OR_CONDO_ASSOCIATION = {
  FIELD_NAME: {
    PART_OF_ASSOCIATION: 'homeownerOrCondoAssociation_partOfAssociation_isEnabled',
    PAY_ANY_FEES: 'homeownerOrCondoAssociation_partOfAssociation_payAnyFees_isEnabled',
    FEE_AMOUNT: 'homeownerOrCondoAssociation_partOfAssociation_payAnyFees_feeAmount',
    MONTHLY_FEE_AMOUNT: 'homeownerOrCondoAssociation_partOfAssociation_payAnyFees_monthlyFeeAmount',
  },
};

export const SMOKING_POLICY = {
  FIELD_NAME: {
    NO_SMOKING: 'smokingPolicy_noSmoking_isEnabled',
    CERTAIN_AREAS: 'smokingPolicy_certainAreas_isEnabled',
    ALLOWED_THROUGHOUT_PROPERTY: 'smokingPolicy_allowedThroughoutProperty_isEnabled',
    INSIDE_UNIT: 'smokingPolicy_certainAreas_insideUnit',
    COMMON_INDOOR_AREAS: 'smokingPolicy_certainAreas_commonIndoorAreas',
    OUTSIDE_MORE_THAN_10_FEET: 'smokingPolicy_certainAreas_outsideMoreThan10Feet',
    PORCHES_PATIOS_YARDS: 'smokingPolicy_certainAreas_porchesPatiosYards',
    CUSTOM_AREA_DESCRIPTION: 'smokingPolicy_certainAreas_customArea_description',
    CUSTOM_AREA_IS_ENABLED: 'smokingPolicy_certainAreas_customArea_isEnabled',
    OTHER_UNITS: 'propertyType_multiFamily_smokingPolicy_otherUnits_isEnabled',
    OTHER_UNITS_DESCRIPTION: 'propertyType_multiFamily_smokingPolicy_otherUnits_description',
    DESIGNATED_OUTDOORS_SMOKING_AREA: 'smokingPolicy_designatedSmokingArea_isEnabled',
    DESIGNATED_OUTDOORS_SMOKING_AREA_DESCRIPTION: 'smokingPolicy_designatedSmokingArea_description',
  },
};

export const ONE_HUNDRED_YEAR_FLOODPLAIN = {
  FIELD_NAME: {
    LOCATED_IN_100_YEAR_FLOODPLAIN: 'oneHundredYearFloodplain_locatedIn100YearFloodplain',
  },
};

export const LANDLORD_INFORMATION = {
  FIELD_NAME: {
    FIRST_NAME: 'landlord_firstName',
    LAST_NAME: 'landlord_lastName',
    ADDRESS: 'landlord_mailingAddress',
    TELEPHONE_NUMBER: 'landlord_telephoneNumber',
    EMAIL: 'landlord_email',
  },
};

export const APPLICANT_SCREENING_FEE = {
  FIELD_NAME: {
    IS_ENABLED: 'applicantScreeningFee_isEnabled',
    AMOUNT: 'applicantScreeningFee_amount',
  },
  BOUNDS: {
    MAX_AMOUNT: 75,
  },
};

export const ADDITIONAL_RULES = {
  FIELD_NAME: {
    PROPERTY_USAGE: PROPERTY_USAGE.FIELD_NAME.IS_ENABLED,
    RESIDENT_ACTIVITIES: RESIDENT_ACTIVITIES.FIELD_NAME.IS_ENABLED,
    KEYS: KEYS.FIELD_NAME.IS_ENABLED,
    CUSTOM: CUSTOM_RULES.FIELD_NAME.IS_ENABLED,
  },
};

export const SECTION_8_HOUSING_VOUCHER = {
  FIELD_NAME: {
    IS_ENABLED: 'section8HousingVoucher_isEnabled',
  },
};

export const UNRELATED_PEOPLE = {
  FIELD_NAME: {
    PEOPLE_ALLOWED: 'unrelatedPeople_peopleAllowed',
  },
};

export const ROAM_TOWING = {
  FIELD_NAME: {
    IS_ENABLED: 'roamTowing_isEnabled',
  },
};

export const TELEPHONE_TV_INTERNET = {
  FIELD_NAME: {
    TELEPHONE_LANDLORD_SET_UP_AND_PAY: 'telephoneTVInternet_telephone_landlordSetUpAndPay',
    TELEPHONE_LANDLORD_SET_UP_AND_MONTHLY_CHARGE:
      'telephoneTVInternet_telephone_landlordSetUpAndMonthlyCharge_isEnabled',
    TELEPHONE_LANDLORD_MONTHLY_CHARGE: 'telephoneTVInternet_telephone_landlordSetUpAndMonthlyCharge_monthlyCharge',
    TELEPHONE_TENANT_SET_UP_AND_PAY: 'telephoneTVInternet_telephone_tenantSetUpAndPay',
    TELEPHONE_NOT_PROVIDED: 'telephoneTVInternet_telephone_notProvided',
    CABLETV_LANDLORD_SET_UP_AND_PAY: 'telephoneTVInternet_cableTV_landlordSetUpAndPay',
    CABLETV_LANDLORD_SET_UP_AND_MONTHLY_CHARGE: 'telephoneTVInternet_cableTV_landlordSetUpAndMonthlyCharge_isEnabled',
    CABLETV_LANDLORD_MONTHLY_CHARGE: 'telephoneTVInternet_cableTV_landlordSetUpAndMonthlyCharge_monthlyCharge',
    CABLETV_TENANT_SET_UP_AND_PAY: 'telephoneTVInternet_cableTV_tenantSetUpAndPay',
    CABLETV_NOT_PROVIDED: 'telephoneTVInternet_cableTV_notProvided',
    INTERNET_LANDLORD_SET_UP_AND_PAY: 'telephoneTVInternet_internet_landlordSetUpAndPay',
    INTERNET_LANDLORD_SET_UP_AND_MONTHLY_CHARGE: 'telephoneTVInternet_internet_landlordSetUpAndMonthlyCharge_isEnabled',
    INTERNET_LANDLORD_MONTHLY_CHARGE: 'telephoneTVInternet_internet_landlordSetUpAndMonthlyCharge_monthlyCharge',
    INTERNET_TENANT_SET_UP_AND_PAY: 'telephoneTVInternet_internet_tenantSetUpAndPay',
    INTERNET_NOT_PROVIDED: 'telephoneTVInternet_internet_notProvided',
  },
};

export const MAXIMUM_NUMBER_OF_OCCUPANTS = {
  FIELD_NAME: {
    MAXIMUM_NUMBER_OF_OCCUPANTS: 'maximumNumberOfOccupants_maximumNumberOfOccupants',
    MAXIMUM_NUMBER_OF_PEOPLE_COMMON_AREA: 'maximumNumberOfOccupants_maximumNumberOfPeopleCommonArea',
    OUTSTANDING_VIOLATIONS: 'maximumNumberOfOccupants_outstandingViolations_isEnabled',
    OUTSTANDING_VIOLATIONS_DESCRIPTION: 'maximumNumberOfOccupants_outstandingViolations_description',
  },
};

export const ASBESTOS = {
  FIELD_NAME: {
    HAS_ON_PROPERTY: 'asbestos_hasOnProperty_isEnabled',
    DESCRIPTION: 'asbestos_hasOnProperty_description',
  },
};

export const METHAMPHETAMINE = {
  FIELD_NAME: {
    DECONTAMINATION: 'methamphetamine_decontamination_isEnabled',
    PREVIOUS_CONTAMINATION: 'methaphetamine_previousContamination_isEnabled',
    NO_CONTAMINATION: 'methamphetamine_noContamination_isEnabled',
    KNOWLEDGE: 'methamphetamine_knowledge_isEnabled',
  },
};

export const DEATH_IN_PROPERTY = {
  FIELD_NAME: {
    NO_DEATH: 'deathInProperty_noDeath_isEnabled',
    NATURAL_CAUSE: 'deathInProperty_naturalCause_isEnabled',
    VIOLENT_CRIME: 'deathInProperty_violentCrime_isEnabled',
    COMMUNICABLE_DISEASE: 'deathInProperty_communicableDisease_isEnabled',
  },
};

export const CONVERSION_PROJECT = {
  FIELD_NAME: {
    IS_ENABLED: 'conversionProject_isEnabled',
  },
};

export const DEMOLITION = {
  FIELD_NAME: {
    IS_ENABLED: 'demolition_isEnabled',
    DEMOLITION_DATE: 'demolition_demolitionDate',
  },
};

export const FLOOD_HAZARD = {
  FIELD_NAME: {
    IS_ENABLED: 'floodHazard_isEnabled',
  },
};

export const PESTICIDES = {
  FIELD_NAME: {
    NO_PESTICIDES: 'pesticides_noPesticides_isEnabled',
    REGISTERED_PEST_CONTROL_COMPANY: 'pesticides_registeredPestControlCompany_isEnabled',
    LANDLORD_LOCATION: 'pesticides_landlordLocation_isEnabled',
    PEST_CONTROLLED: 'pesticides_landlordLocation_pestControlled',
    NAME_AND_BRAND: 'pesticides_landlordLocation_nameAndBrand',
    SCHEDULE: 'pesticides_landlordLocation_schedule',
    PESTICIDES_LOCATION: 'pesticides_landlordLocation_pesticidesLocation',
  },
};

export const MILITARY_FACILITIES = {
  FIELD_NAME: {
    IS_ENABLED: 'militaryFacilities_isEnabled',
  },
};

export const FIRE_SAFETY = {
  FIELD_NAME: {
    FIRE_EXTINGUISHER_LOCATION: 'propertyType_multiFamily_threeUnitsOrMore_fireSafety_fireExtinguisherLocation',
    FIRE_EXTINGUISHER_SERVICE_DATE: 'propertyType_multiFamily_threeUnitsOrMore_fireSafety_fireExtinguisherServiceDate',
    EMERGENCY_EXIT_LOCATION: 'propertyType_multiFamily_threeUnitsOrMore_fireSafety_emergencyExitLocation',
    SMOKE_ALARM_REPLACED_DATE: 'propertyType_multiFamily_threeUnitsOrMore_fireSafety_smokeAlarmReplacedDate',
    CARBON_MONOXIDE_ALARM_REPLACED_DATE:
      'propertyType_multiFamily_threeUnitsOrMore_fireSafety_carbonMonoxideReplacedDate',
  },
};

export const FIRE_ESCAPE = {
  FIELD_NAME: {
    FIRE_ESCAPE: 'propertyType_multiFamily_threeUnitsOrMore_fireEscape_isEnabled',
    FIRE_ESCAPE_LOCATION: 'propertyType_multiFamily_threeUnitsOrMore_fireEscape_location',
    FIRE_ESCAPE_SERVICE_DATE: 'propertyType_multiFamily_threeUnitsOrMore_fireEscape_serviceDate',
  },
};

export const FIRE_ALARM = {
  FIELD_NAME: {
    FIRE_ALARM: 'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_isEnabled',
    FIRE_ALARM_PULL_STATION_LOCATION: 'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_pullStationLocation',
    FIRE_ALARM_CONTROL_PANEL_LOCATION: 'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_controlPanelLocation',
    FIRE_ALARM_CONTROL_PANEL_SERVICE_DATE:
      'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_controlPanelServiceDate',
    UL_CERITIFICATION_NUMBER: 'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_uLCertificationNumber',
    UL_EXPIRATION_DATE: 'propertyType_multiFamily_threeUnitsOrMore_fireAlarm_uLExpirationDate',
  },
};

export const PRODUCTION_DISTRIBUTION_REPAIR = {
  FIELD_NAME: {
    IS_ENABLED: 'productionDistributionRepair_isEnabled',
  },
};

export const RECYCLING_PROCEDURES = {
  FIELD_NAME: {
    DESCRIPTION: 'recyclingProcedures_description',
    CONTAINER_LOCATION: 'recyclingProcedures_containerLocation',
    PICKUP_SCHEDULE: 'recyclingProcedures_recyclingSchedule',
    PROVIDER: 'recyclingProcedures_provider',
    PROVIDER_PHONE_NUMBER: 'recyclingProcedures_providerPhoneNumber',
  },
};

export const TENANT_PROTECTION = {
  FIELD_NAME: {
    IS_ENABLED: 'tenantProtection_isEnabled',
  },
};

export const FLOODPLAIN = {
  FIELD_NAME: {
    IS_ENABLED: 'floodplain_isEnabled',
  },
};

export const DEFICIENCIES_AND_CITATIONS = {
  FIELD_NAME: {
    IS_ENABLED: 'deficienciesAndCitations_isEnabled',
    DESCRIPTION: 'deficienciesAndCitations_description',
  },
};

export const UTILITIES_INFORMATION = {
  FIELD_NAME: {
    ELECTRICITY_PHONE_NUMBER: 'utilitiesInformation_electricityPhoneNumber',
    WATER_SEWER_PHONE_NUMBER: 'utilitiesInformation_waterSewerPhoneNumber',
    TRASH_REMOVAL_PHONE_NUMBER: 'utilitiesInformation_trashRemovalPhoneNumber',
    HEATING_OIL_PHONE_NUMBER: 'utilitiesInformation_heatingOilPhoneNumber',
    NATURAL_GAS_PHONE_NUMBER: 'utilitiesInformation_naturalGasPhoneNumber',
    ELECTRICITY_SERVICE_PROVIDER: 'utilitiesInformation_electricityServiceProvider',
    WATER_SEWER_SERVICE_PROVIDER: 'utilitiesInformation_waterSewerServiceProvider',
    TRASH_REMOVAL_SERVICE_PROVIDER: 'utilitiesInformation_trashRemovalServiceProvider',
    HEATING_OIL_SERVICE_PROVIDER: 'utilitiesInformation_heatingOilServiceProvider',
    NATURAL_GAS_SERVICE_PROVIDER: 'utilitiesInformation_naturalGasServiceProvider',
  },
};

export const RENT_ADJUSTMENT = {
  FIELD_NAME: {
    INITIAL_RENT_WITHOUT_LIMITATIONS: 'rentAdjustment_initialRentWithoutLimitations_isEnabled',
    RENT_IN_EFFECT_PRIOR: 'rentAdjustment_initialRentWithoutLimitations_rentInEffectPrior',
  },
  BOUNDS: {
    MAX_AMOUNT: 100000,
  },
};

export const TENANT_MAINTENANCE = {
  FIELD_NAME: {
    IS_ENABLED: 'tenantMaintenance_isEnabled',
    TENANT_MAINTENANCE_DESCRIPTION: 'tenantMaintenance_description',
  },
};

export const OTHER_METHOD_VALUE = 'Any other method that fairly allocates the charges';

export const UTILITY_CALCULATION_LISTBOX_OPTIONS = [
  {
    value: 'Direct or submetering system that shows actual usage',
    label: 'Direct or submetering system that shows actual usage',
  },
  {
    value: 'Per tenant',
    label: 'Per tenant',
  },
  {
    value: 'Proportionately by livable square footage',
    label: 'Proportionately by livable square footage',
  },
  {
    value: 'Per type of unit',
    label: 'Per type of unit',
  },
  {
    value: 'Per number of bedrooms in unit',
    label: 'Per number of bedrooms in unit',
  },
  {
    value: OTHER_METHOD_VALUE,
    label: OTHER_METHOD_VALUE,
  },
];

export const WATER_SEWER_UTILITY_CALCULATION_LISTBOX_OPTIONS = [
  {
    value: 'Direct or submetering system that shows actual usage',
    label: 'Direct or submetering system that shows actual usage',
  },
  {
    value: 'Per tenant',
    label: 'Per tenant',
  },
  {
    value: 'Proportionately by livable square footage',
    label: 'Proportionately by livable square footage',
  },
  {
    value: 'Per type of unit',
    label: 'Per type of unit',
  },
  {
    value: 'Per number of bedrooms in unit',
    label: 'Per number of bedrooms in unit',
  },
  {
    value: 'Per number of water fixtures',
    label: 'Per number of water fixtures',
  },
  {
    value:
      'For water and wastewater, by use of an individually submetered hot water usage measure for the tenant’s dwelling unit',
    label:
      'For water and wastewater, by use of an individually submetered hot water usage measure for the tenant’s dwelling unit',
  },
  {
    value: OTHER_METHOD_VALUE,
    label: OTHER_METHOD_VALUE,
  },
];

export const ELECTRIC_VEHICLE_CHARGING = {
  FIELD_NAME: {
    IS_ENABLED: 'parking_provided_electricVehicleCharging_isEnabled',
    PERSONAL_LIABILITY_INSURANCE: 'parking_provided_electricVehicleCharging_personalLiabilityInsurance_isEnabled',
    PERSONAL_LIABILITY_INSURANCE_AMOUNT: 'parking_provided_electricVehicleCharging_personalLiabilityInsurance_amount',
    INSTALLATION_USE_MAINTENANCE: 'parking_provided_electricVehicleCharging_installationUseMaintenance_isEnabled',
    SEPARATELY_METERED: 'parking_provided_electricVehicleCharging_separatelyMetered_isEnabled',
    SERVICE_PROVIDER: 'parking_provided_electricVehicleCharging_separatelyMetered_serviceProvider',
  },
};

export const SPRINGFIELD_ZONING_REQUIREMENTS = {
  FIELD_NAME: {
    IS_ENABLED: 'springfieldZoningRequirements_isEnabled',
  },
};

export const PROPERTY_CONDITION_CHECKLIST_OPTIONS = {
  FIELD_NAME: {
    UPLOAD_OWN: 'propertyConditionChecklistOptions_uploadOwn',
    ATTACH_BLANK: 'propertyConditionChecklistOptions_attachBlank',
  },
};

export const SWIMMING_POOL = {
  FIELD_NAME: {
    IS_ENABLED: 'swimmingPool_isEnabled',
  },
};

export const WASTE_AND_RECYCLING = {
  FIELD_NAME: {
    COLLECTION_DAY: 'wasteAndRecycling_collectionDay',
    OUTSIDE_STORAGE_LOCATION: 'wasteAndRecycling_outsideStorageLocation',
  },
};

export const BED_BUGS = {
  FIELD_NAME: {
    IS_ENABLED: 'bedBugs_isEnabled',
    DESCRIPTION: 'bedBugs_description',
  },
};

export const VAPOR_INTRUSION_ZONE = {
  FIELD_NAME: {
    IS_ENABLED: 'vaporIntrusionZone_isEnabled',
    HAS_BEEN_TESTED: 'vaporIntrusionZone_hasBeenTested',
    REPORT_IS_ENABLED: 'vaporIntrusionZoneReport_isEnabled',
    REPORT_NAME: 'vaporIntrusionZoneReport_name',
    REPORT_NUMBER: 'vaporIntrusionZoneReport_number',
    REPORT_DATE: 'vaporIntrusionZoneReport_date',
  },
};

export const ARSENIC_CONTAMINATION_ZONE = {
  FIELD_NAME: {
    IS_ENABLED: 'arsenicContaminationZone_isEnabled',
    HAS_BEEN_TESTED: 'arsenicContaminationZone_hasBeenTested',
    REPORT_IS_ENABLED: 'arsenicContaminationZoneReport_isEnabled',
    REPORT_NAME: 'arsenicContaminationZoneReport_name',
    REPORT_NUMBER: 'arsenicContaminationZoneReport_number',
    REPORT_DATE: 'arsenicContaminationZoneReport_date',
  },
};

export const EMERGENCY_CONTACT = {
  FIELD_NAME: {
    FIRST_NAME: 'emergencyContact_firstName',
    LAST_NAME: 'emergencyContact_lastName',
    PHONE_NUMBER: 'emergencyContact_phoneNumber',
  },
};

export const CERTIFICATE_OF_INSPECTION = {
  FIELD_NAME: {
    IS_ENABLED: 'certificateOfInspection_isEnabled',
  },
};

export const NOTICES_OF_CODE_VIOLATIONS = {
  FIELD_NAME: {
    IS_ENABLED: 'noticesOfCodeViolations_isEnabled',
    CASE_NUMBER_IS_ENABLED: 'noticesOfCodeViolations_caseNumber_isEnabled',
    CASE_NUMBER: 'noticesOfCodeViolations_caseNumber_number',
    IDENTIFICATION_NUMBER_IS_ENABLED: 'noticesOfCodeViolations_identificationNumber_isEnabled',
    IDENTIFICATION_NUMBER: 'noticesOfCodeViolations_identificationNumber_number',
    LISTING_OF_CODE_VIOLATION: 'noticesOfCodeViolations_listingOfCodeViolation',
    DESCRIPTION: 'noticesOfCodeViolations_description',
  },
};

export const NOTICES_UTILITY_TERMINATION = {
  FIELD_NAME: {
    IS_ENABLED: 'noticesUtilityTermination_isEnabled',
    UTILITY_SERVICE: 'noticesUtilityTermination_utilityService',
    DATE_OF_TERMINATION: 'noticesUtilityTermination_dateOfTermination',
    TERMINATION_AFFECT_COMMON_AREA: 'noticesUtilityTermination_terminationAffectCommonArea_isEnabled',
  },
};

export const HEATING_CHARGE = {
  FIELD_NAME: {
    MONTHLY_CHARGE: 'heatingCharge_monthlyCharge',
    ANNUAL_CHARGE: 'heatingCharge_annualCharge',
  },
};

export const LIVING_SPACE_FLOODING = {
  FIELD_NAME: {
    IS_ENABLED: 'livingSpaceFlooding_isEnabled',
    DESCRIPTION: 'livingSpaceFlooding_description',
  },
};

export const FIRE_SAFETY_AND_PROTECTION = {
  FIELD_NAME: {
    BATTERY_POWERED: 'fireSafetyAndProtection_batteryPowered',
    HARD_WIRED: 'fireSafetyAndProtection_hardWired',
    BATTERY_POWERED_AND_HARD_WIRED: 'fireSafetyAndProtection_batteryPoweredAndHardWired',
    FIRE_SPRINKLER_SYSTEM: 'fireSafetyAndProtection_fireSprinklerSystem_isEnabled',
    FIRE_ALARM_SYSTEM: 'fireSafetyAndProtection_fireAlarmSystem_isEnabled',
    SMOKING_POLICY: 'fireSafetyAndProtection_smokingPolicy_isEnabled',
    EMERGENCY_NOTIFICATION_PLAN: 'fireSafetyAndProtection_emergencyNotificationPlan_isEnabled',
    EMERGENCY_RELOCATION_PLAN: 'fireSafetyAndProtection_emergencyRelocationPlan_isEnabled',
    EMERGENCY_EVACUATION_PLAN: 'fireSafetyAndProtection_emergencyEvacuationPlan_isEnabled',
  },
};
